import {
  requestPointPresent,
  requestCoupon,
} from '@/api/coupon';

const state = {
  resultCouponUseError: null,
  resultCouponPointPresent: null,
};

const getters = {
  resultCouponUseError: (state) => state.resultCouponUseError,
  resultCouponPointPresent: (state) => state.resultCouponPointPresent,
};

const actions = {
  async useCoupon({ commit, dispatch, rootGetters }, { couponCode }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = { couponCode };
    const result = await requestCoupon({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestCoupon', result.data.error);
    await dispatch('setIsLoading', false, { root: true });
  },
  async pointPresent({ commit, dispatch, rootGetters }, { pointPriceId }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = { pointPriceId };
    const result = await requestPointPresent({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestPointPresent', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  clearCoupon({ commit }) {
    commit('setRequestCoupon', null);
  },
};

const mutations = {
  setRequestCoupon(state, data) {
    state.resultCouponUseError = data;
  },
  setRequestPointPresent(state, data) {
    state.resultCouponPointPresent = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
